export class LogosCompany {
  id: number;
  title: string;
  picturePath: string;
  constructor(logoData: any) {
    this.id = logoData.id;
    this.title = logoData.title;
    this.picturePath = logoData.picturePath;
  }
  }
